import { createElement as $$createElement, setStyle as $$setStyle, setDataset as $$setDataset, setEvent as $$setEvent, delegateEvent as $$delegateEvent, setHTMLProp as $$setHTMLProp, setHTMLAttr as $$setHTMLAttr, setHTMLProps as $$setHTMLProps, setHTMLAttrs as $$setHTMLAttrs, createTextNode as $$createTextNode, updateText as $$updateText, insertNode as $$insertNode, ForNode as $$ForNode, CondNode as $$CondNode, ExpNode as $$ExpNode, EnvNode as $$EnvNode, TryNode as $$TryNode, SnippetNode as $$SnippetNode, PropView as $$PropView, render as $$render } from "@dlightjs/dlight";
import { CSSProperties, DLightViewProp, Pretty, Typed, View, required } from "@dlightjs/dlight";
import { injectFuncToInitNodes } from "../Injection/utils";
interface ZStackProps {
  hAlignment?: "leading" | "center" | "tailing";
  vAlignment?: "top" | "center" | "bottom";
  width?: string;
  height?: string;
  style?: CSSProperties;
  class?: string;
}
class ZStack extends View implements ZStackProps {
  constructor() {
    super();
    this.setStyles = this.setStyles.bind(this);
    this.didMount = this.didMount.bind(this);
  }
  $p$hAlignment;
  hAlignment: ZStackProps["hAlignment"] = "center";
  $$hAlignment = 1;
  $s$hAlignment = ["justifyItems"];
  $p$vAlignment;
  vAlignment: ZStackProps["vAlignment"] = "center";
  $$vAlignment = 2;
  $s$vAlignment = ["alignItems"];
  $p$width;
  width = "max-content";
  $$width = 4;
  $p$height;
  height = "max-content";
  $$height = 8;
  $p$style;
  style?: ZStackProps["style"] = {};
  $$style = 16;
  $p$class;
  class?: ZStackProps["class"];
  $$class = 32;
  get children() {
    return this._$children;
  }
  justifyItems;
  $$justifyItems = 64;
  get $f$justifyItems() {
    if (this._$cache("justifyItems", [this.hAlignment])) {
      return this.justifyItems;
    }
    return {
      leading: "flex-start",
      center: "center",
      tailing: "flex-end"
    }[this.hAlignment!] ?? "center";
  }
  alignItems;
  $$alignItems = 128;
  get $f$alignItems() {
    if (this._$cache("alignItems", [this.vAlignment])) {
      return this.alignItems;
    }
    return {
      top: "flex-start",
      center: "center",
      bottom: "flex-end"
    }[this.vAlignment!] ?? "center";
  }
  nodes: any[] = [];
  setStyles(nodes: any) {
    View.loopShallowEls(nodes, (el: HTMLElement) => {
      el.style.position = "absolute";
      el.style.gridArea = "1 / 1/ 1 / 1";
    });
  }
  didMount() {
    this.setStyles(this.nodes);
    injectFuncToInitNodes(this.nodes, this.setStyles);
  }
  Body() {
    let $node0, $node1;
    this._$update = $changed => {
      if ($changed & 32) {
        $node0 && $$setHTMLProp($node0, "className", () => this.class, [this.class]);
      }
      if ($changed & 223) {
        $node0 && $$setStyle($node0, {
          ...this.style,
          height: this.height,
          width: this.width,
          display: "grid",
          alignItems: this.alignItems,
          justifyItems: this.justifyItems
        });
      }
    };
    $node0 = $$createElement("div");
    $$setHTMLProp($node0, "className", () => this.class, [this.class]);
    $$setStyle($node0, {
      ...this.style,
      height: this.height,
      width: this.width,
      display: "grid",
      alignItems: this.alignItems,
      justifyItems: this.justifyItems
    });
    $node1 = new $$ExpNode(this.children, []);
    View.addDidMount($node1, (node: any) => {
      this.nodes = node._$nodes;
    });
    $$insertNode($node0, $node1, 0);
    $node0._$nodes = [$node1];
    return [$node0];
  }
}
export default ((ZStack as Pretty) as Typed<ZStack>);